import * as THREE from 'three';

/**
 * Mercator projection scale factor lookup table.
 * This table caches the scale factors for different latitudes to optimize performance.
 * The keys are latitudes multiplied by 1000 to avoid floating point precision issues.
 * The values are the corresponding Mercator scale factors.
 */
const mercatorScaleLookup: { [key: number]: number } = {};

/**
 * Calculates the Mercator scale for a given latitude.
 * This function computes the scale factor for the Mercator projection at a specific latitude.
 * It uses a lookup table to cache results for performance optimization.
 * @param lat - Latitude in degrees
 * @returns The Mercator scale factor at the specified latitude
 */
export const getMercatorScale = (lat: number): number => {
  const index = Math.round(lat * 1000);
  if (mercatorScaleLookup[index] === undefined) {
    mercatorScaleLookup[index] = 1 / Math.cos(lat * THREE.MathUtils.DEG2RAD);
  }
  return mercatorScaleLookup[index];
};
